import Vue from 'vue'
import vueCustomElement from 'vue-custom-element'
import 'document-register-element/build/document-register-element'; // IE polyfill
Vue.use(vueCustomElement)

import VNews from './VNews/VNews.vue';
Vue.customElement('v-news', VNews)
